"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const axios_1 = require("axios");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const FormLabel_1 = require("../../../../material-ui-theme/components/styled/FormLabel");
const approvalQuery_1 = require("../../../../queries/approvals/approvalQuery");
const companyQuery_1 = require("../../../../queries/companyQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const Root_1 = require("../../../../router/Root");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const drawerAside_1 = __importDefault(require("../../../organisms/drawerAside"));
const logger = (0, pino_1.default)();
const differenceBy = (arr1, arr2, iteratee) => {
    return arr1?.filter(c => !arr2?.map(iteratee).includes(iteratee(c))) || [];
};
const ForwardRequestAside = () => {
    const { setOpenForwardRequestAside, setShowCreateFwdButtons, setNotification, setIsForwardRequestButtonDisabled, setPageLoading, approvals, } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { openForwardRequestAside, currentApprovalItem: approvalItem } = approvals;
    const params = (0, react_router_1.useParams)();
    const { data: approvers, isLoading: approversLoading } = (0, approvalQuery_1.useGetTeamApproversQuery)({
        teamId: approvalItem?.request.teamId,
        approverId: approvalItem?.context.assignedUserId,
    });
    const [approver, setApprover] = (0, react_1.useState)({ id: '', label: '', email: '' });
    const [reason, setReason] = (0, react_1.useState)('');
    const forwardRequest = (0, approvalQuery_1.useForwardRequestMutation)();
    const { data: userData } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(userData?.companyAccountId, {
        cardprovider: 'tsgo-cardprovider',
    }));
    const cardProvider = companyPropertiesData?.cardprovider;
    const isHsbcCardProvider = cardProvider === 'HSBC';
    const userIdWhoCreatedTheRequest = approvalItem?.assigner;
    const shouldDisableTheFormSubmition = isHsbcCardProvider ? userData?.userId === userIdWhoCreatedTheRequest : false;
    const { data: companyAdminUsers } = (0, react_query_1.useQuery)({ ...(0, userQuery_1.getUsersByRoleId)(appConstants_1.companyAdmin) });
    const adminsAsApprovers = companyAdminUsers?.users?.map(user => ({
        id: user.userId,
        label: user.fullName,
        email: user.email,
    }));
    const tempApprovers = (0, react_1.useMemo)(() => {
        return approvers?.filter((filteredApprover) => filteredApprover?.id !== approvalItem?.assigner) || [];
    }, [approvers, approvalItem?.assigner]);
    const validApprovers = (0, react_1.useMemo)(() => {
        return differenceBy(tempApprovers, adminsAsApprovers, ({ id }) => id);
    }, [adminsAsApprovers, tempApprovers]);
    const forwardRequestSubmit = () => {
        if (!approvalItem) {
            logger.error('Approval item is not defined');
            setNotification([
                {
                    type: strings_1.notificationStrings.ERROR,
                    message: 'Approval item is not defined',
                },
            ]);
            return;
        }
        setPageLoading(true);
        setIsForwardRequestButtonDisabled(true);
        const payload = {
            assignee: approver,
            approval: approvalItem,
            reason,
        };
        forwardRequest.mutate(payload, {
            onSuccess: () => {
                setOpenForwardRequestAside(false);
                setShowCreateFwdButtons(true);
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: 'Request forwarded',
                    },
                ]);
            },
            onError: (err) => {
                logger.error(err);
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: (0, axios_1.isAxiosError)(err) ? err.message : 'Error with forward request',
                    },
                ]);
            },
            onSettled: () => {
                setApprover({ id: '', label: '', email: '' });
                setReason('');
                setOpenForwardRequestAside(false);
                setIsForwardRequestButtonDisabled(false);
                if (params?.['approvalId']) {
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: ['approval', params?.['approvalId']],
                    });
                }
                setPageLoading(false);
            },
        });
    };
    const onCloseForwardAside = () => {
        setOpenForwardRequestAside(false);
        setApprover({ id: '', label: '', email: '' });
        setReason('');
    };
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "forward-button", disabled: !approver?.id || shouldDisableTheFormSubmition || forwardRequest.isPending, onClick: forwardRequestSubmit, color: uiConstants_1.UI_BUTTON_PRIMARY, label: strings_1.approvalsStrings.FORWARD_BUTTON }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-button", color: uiConstants_1.UI_BUTTON_SECONDARY, onClick: onCloseForwardAside, label: strings_1.approvalsStrings.FWD_CANCEL_BUTTON })] }));
    return ((0, jsx_runtime_1.jsxs)(drawerAside_1.default, { id: "forwardRequest", title: strings_1.approvalsStrings.FORWARD_REQUEST, open: openForwardRequestAside, onClose: onCloseForwardAside, footerButtons: footerButtons, children: [shouldDisableTheFormSubmition ? ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", variant: "filled", "ts-variant": "warning", children: "The request was created by the current user therefore forwarding is disabled." })) : null, validApprovers.length === 0 &&
                !approversLoading &&
                !shouldDisableTheFormSubmition &&
                globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", variant: "filled", "ts-variant": "warning", children: strings_1.approvalsStrings.NO_APPROVERS_TEXT })) : null, (0, jsx_runtime_1.jsxs)(material_1.FormGroup, { style: { margin: 1, justifyContent: 'space-between', flex: 1 }, children: [(0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.approvalsStrings.SELECT_APPROVER }), (0, jsx_runtime_1.jsxs)(material_1.Select, { "data-testid": 'approverSelect', name: 'approversId', required: true, disabled: shouldDisableTheFormSubmition, value: approver?.id || '', inputProps: { placeholder: strings_1.approvalsStrings.APPROVER_PLACEHOLDER }, onChange: event => {
                                    if (event?.target?.value) {
                                        const selectedApprover = approvers.find(approver => approver.id === event.target.value);
                                        setApprover(selectedApprover);
                                    }
                                }, children: [tempApprovers.length > 0 && !globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                        ? tempApprovers.map((mappedApprover) => {
                                            return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: mappedApprover.id, children: mappedApprover.label }, mappedApprover.id));
                                        })
                                        : null, validApprovers.length > 0 && globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                        ? validApprovers.map((mappedApprover) => {
                                            return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: mappedApprover.id, children: mappedApprover.label }, mappedApprover.id));
                                        })
                                        : null] })] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1, pl: 0, pr: 0 }, disabled: shouldDisableTheFormSubmition, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { sx: { ml: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 0 : 1 }, disabled: shouldDisableTheFormSubmition, children: strings_1.approvalsStrings.REASON }), (0, jsx_runtime_1.jsx)(material_1.TextField, { "data-testid": "reason", placeholder: strings_1.approvalsStrings.REASON_PLACEHOLDER, name: "reason", disabled: shouldDisableTheFormSubmition, multiline: true, minRows: 5, maxRows: 70, value: reason, onChange: e => setReason(e.target.value), sx: {
                                    '& .MuiOutlinedInput-root': {
                                        padding: '10px 0px',
                                    },
                                } })] })] })] }));
};
exports.default = ForwardRequestAside;
